"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultItemDescriptionConfig = exports.defaultItemTitleConfig = exports.defaultSectionConfig = void 0;
var defaultSectionConfig = {
    dark: false
};
exports.defaultSectionConfig = defaultSectionConfig;
var defaultItemTitleConfig = {
    align: 'left',
    size: 4,
    margin: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    }
};
exports.defaultItemTitleConfig = defaultItemTitleConfig;
var defaultItemDescriptionConfig = {
    align: 'left'
};
exports.defaultItemDescriptionConfig = defaultItemDescriptionConfig;
//# sourceMappingURL=OldwayNewway.js.map